import { unstableSetRender } from 'antd';
import { createRoot } from 'react-dom/client';

// Ant Design 5's static confirmation/message roots need an explicit React 19
// renderer. Keep this at the shared entry point so every host receives the fix.
// https://5x-ant-design.antgroup.com/docs/react/v5-for-19
const roots = new WeakMap();
unstableSetRender((node, container) => {
  let root = roots.get(container);
  if (!root) {
    root = createRoot(container);
    roots.set(container, root);
  }
  root.render(node);
  return async () => {
    // Avoid synchronously unmounting a root during another React render.
    await new Promise(resolve => setTimeout(resolve, 0));
    if (roots.get(container) === root) {
      root.unmount();
      roots.delete(container);
    }
  };
});
